import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, FroalaEditorModule.forRoot(), FroalaViewModule.forRoot()],
})
export class TextEditorModule {}
